import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IBalanceCorrectionsListItem } from '../types';
import {
  BALANCE_CORRECTIONS_LIST_API_URL,
  BALANCE_CORRECTIONS_LIST_QUERY_KEY,
  BALANCE_CORRECTIONS_PERMISSIONS,
} from '../constants';

export default function useBalanceCorrectionsListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IBalanceCorrectionsListItem>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IBalanceCorrectionsListItem>>({
    queryKey: [BALANCE_CORRECTIONS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IBalanceCorrectionsListItem>>(
      BALANCE_CORRECTIONS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: BALANCE_CORRECTIONS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
